var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"centered":"","hide-footer":"","id":"modal-lg","size":"xl"}},[_c('div',[(_vm.tipoResource == 'img')?_c('b-img',{attrs:{"block":true,"fluid":true,"src":_vm.imgMidia,"alt":" Carregando Imagem..."}}):_c('b-embed',{attrs:{"type":"iframe","aspect":"21by9","src":_vm.imgMidia,"allowfullscreen":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }